// extracted by mini-css-extract-plugin
export default {"container":"ProfileData_container__Cyut1","wrapper":"ProfileData_wrapper__GE981","content":"ProfileData_content__5WFcC","divider":"ProfileData_divider__H8PAr"};